<template>
  <div>
    <div class="card-header">
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item clickable">
          <span class="nav-link" :class="activeTab === 'overview' ? 'active bg-white' : ''" @click="activeTab = 'overview'">
            {{ $t('labels.overview') }}
          </span>
        </li>
        <li v-if="false" class="nav-item clickable">
          <span class="nav-link" :class="activeTab === 'timers' ? 'active bg-white' : ''" @click="activeTab = 'timers'">
            {{ $tc('labels.timer', 0) }}
          </span>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <h5 class="card-title">
        {{ project.title }}<br>
        <small>{{ find(customers, 'id', project.customer_id, 'name') }}</small>
      </h5>
      <p class="card-text">{{ project.description }}</p>
      <button v-if="project.timer && !project.timer.ended_at" class="btn bg-red" @click="this.stop">
        <fa-icon :icon="['fas', 'stop-circle']" />
        <timer class="ml-2" :timer="project.timer" />
      </button>
      <button v-else class="btn bg-green" @click="this.submit">
        <fa-icon :icon="['fas', 'play-circle']" />
        <span class="ml-2">{{ $t('labels.action_resource', { action: $t('labels.start'), resource: $tc('labels.timer', 1) }) }}</span>
      </button>
      <div class="mt-3 d-flex align-items-center" v-if="project.timer && !project.timer.ended_at">
        <span>Timer Started at {{ project.timer.created_at | datetime }}</span>
        <bs-button class="btn-sm btn-warning ml-3" @click="adjust(project.timer)">Adjust</bs-button>
      </div>
    </div>
    <bs-modal :name="'create-' + project.id + '-' + $options.name" :label="$t('labels.action_resource', { action: $t('labels.submit'), resource: $tc('labels.timer', 1) })">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="{ error }">
          <tuxedo-date :type="'datetime'" :name="'created_at'" :label="$t('labels.started')" :minuteStep="1" v-model="resource.created_at" :error="error" />
          <tuxedo-date :type="'datetime'" :name="'ended_at'" :label="$t('labels.ended')" :minuteStep="1" v-model="resource.ended_at" :error="error" />
          <tuxedo-input :name="'description'" :label="$t('labels.description')" v-model="resource.description" :error="error" />
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'adjustTimer'" :label="$t('labels.action_resource', { action: $t('labels.submit'), resource: $tc('labels.timer', 1) })">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="{ error }">
          <tuxedo-date :type="'datetime'" :name="'created_at'" :label="$t('labels.started')" :minuteStep="1" v-model="resource.created_at" :error="error" />
        </template>
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import helpers from '../../helpers.js'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'MyProject',
  mixins: [resourceControl],
  props: ['project'],
  data () {
    return {
      view: 'silent',
      activeTab: 'overview',
      resource: {
        created_at: null,
        user_id: null,
        description: ''
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      customers: state => state.customersStore
    }),
    apiTarget () {
      return ['projects', this.project.id, 'timers']
    }
  },
  methods: {
    ...helpers,
    afterSubmit (res) {
      this.$modal.hide('adjustTimer')
      this.$modal.hide('create-' + this.project.id + '-' + this.$options.name)
      this.$emit('reload')
      this.$store.commit('mergeState', {
        collection: 'projectsStore',
        targetUsing: 'resource_id',
        mergeAs: 'timer',
        data: res.data.data
      })
    },
    stop () {
      const start = new Date(this.project.timer.created_at)
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(this.project.timer))
      this.resource.created_at = start
      this.resource.ended_at = new Date()
      this.$modal.show('create-' + this.project.id + '-' + this.$options.name)
    },
    adjust (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('adjustTimer')
    }
  }
}
</script>
